import type { Nav, } from "@bracket/prisma";



/**
 * Calculates the percentage change between draft and stored values for a given Nav property
 * @param prop - The Nav property to compare
 * @param draft - The draft Nav object containing new values
 * @param stored - The stored Nav object containing original values
 * @returns Formatted percentage change string (e.g. "+5.0%" or "-2.5%") or "-" for no change/invalid values
 */
export const getPercChange = (
	prop: keyof Nav,
	draft: Nav,
	stored: Nav,
) => {
	const perc = (Number(draft[prop]) / Number(stored[prop])) * 100;
	if(Number.isNaN(perc) || perc === 0 || perc === Infinity) {
		return "-";
	}
	const offset = perc - 100;
	return `${offset > 0 ? "+" : ""}${offset.toFixed(1)}%`;
	
};
